import styled from '@emotion/styled';
import { Link } from 'react-router-dom';

import _NextIcon from '@/assets/icons/icon_next_gray.svg';
import _TwitterIcon from '@/assets/icons/icon_twitter.svg';
import { mq } from '@/utility/mediaQuery';
import { defaultTheme } from '@/utility/theme';
import { hoverHighlight, hoverOpacity } from '@/utility/theme/animation';

export const LinkArea = styled.div(() =>
  mq({
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
    borderTop: `1px solid ${defaultTheme.border.color.mediumLightGray}`,
    paddingTop: defaultTheme.spacing.m,
    marginTop: '32px',
  }),
);

export const NextIcon = styled.i(() =>
  mq({
    display: 'inline-block',
    width: '9px',
    height: '16px',
    backgroundSize: 'contain',
    backgroundRepeat: 'no-repeat',
    backgroundImage: `url(${_NextIcon})`,
  }),
);

export const PrevIcon = styled(NextIcon)(() =>
  mq({
    transform: 'rotate(-180deg)',
  }),
);

export const DisabledLink = styled.div(() =>
  mq({
    display: 'flex',
    alignItems: 'center',
    opacity: defaultTheme.button.opacity.disabled,
    '& > span': {
      fontSize: '14px',
      margin: `0 ${defaultTheme.spacing.s}`,
    },
  }),
);

export const StyledLink = styled(DisabledLink)(() =>
  mq({
    opacity: 1,
    ...hoverHighlight,
  }),
).withComponent(Link);

export const Author = styled.div(() =>
  mq({
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    backgroundColor: defaultTheme.background.lightGray,
    padding: defaultTheme.spacing.xxl,
    marginTop: ['32px', '32px', '64px', '64px'],
  }),
);

export const ProfileInfo = styled.div(() =>
  mq({
    display: 'grid',
    gridTemplateColumns: '64px auto',
    gridColumnGap: defaultTheme.spacing.l,
    alignItems: 'center',
    marginBottom: defaultTheme.spacing.l,
  }),
);

export const AuthorImage = styled.div(() =>
  mq({
    width: '64px',
    height: '64px',
    '& img': {
      objectFit: 'cover',
      borderRadius: defaultTheme.border.radius.circle,
    },
  }),
);

export const AuthorName = styled(Link)(() =>
  mq({
    fontSize: defaultTheme.font.size.l,
    fontWeight: 'bold',
    textDecorationLine: 'underline',
    ...hoverOpacity,
  }),
);

export const SnsLinks = styled.div(() =>
  mq({
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 24px)',
    gridTemplateRows: '24px',
    gridColumnGap: defaultTheme.spacing.s,
    marginTop: defaultTheme.spacing.s,
    '& > a': {
      ...hoverOpacity,
    },
  }),
);

export const Description = styled.p(() =>
  mq({
    width: '100%',
    fontSize: defaultTheme.font.size.s,
  }),
);

export const TwitterIcon = styled.i(() =>
  mq({
    display: 'block',
    width: '24px',
    height: '24px',
    backgroundImage: `url(${_TwitterIcon})`,
    backgroundSize: 'contain',
    backgroundRepeat: 'no-repeat',
  }),
);
